export default "__VITE_ASSET__vjx8ljHN__"